import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useReveal from '@/hooks/useReveal';

export default function PrivacyPage() {
  useReveal();
  return (
    <div className="bg-ink-950 text-white">
      <Navbar />
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Ultra%20dark%20cinematic%20abstract%20digital%20security%20lock%20and%20shield%20with%20purple%20neon%20glow%20on%20deep%20black%20background%20premium%20technology%20cybersecurity%20visualization%20clean%20minimalist%20composition&width=1800&height=1200&seq=fc-legal-bg&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink-950/80 via-ink-950/70 to-ink-950" />
        <div className="relative mx-auto max-w-7xl px-6 pt-32 pb-16 w-full">
          <h1 className="font-display text-4xl md:text-6xl font-bold text-gradient">Privacy Policy</h1>
          <p className="mt-4 text-white/60">Last updated: August 2026</p>
        </div>
      </section>
      <section className="relative py-20 px-6">
        <div className="mx-auto max-w-3xl space-y-10">
          {[{
            title: '1. Information We Collect',
            text: 'We collect information you provide directly to us, such as your name, email address, phone number, company details, and project requirements when you fill out our contact or project inquiry forms. We may also collect technical data such as IP address, browser type, and usage patterns through cookies and analytics tools.',
          }, {
            title: '2. How We Use Your Information',
            text: 'We use your information to respond to inquiries, deliver our services, improve our website, send occasional updates (with your consent), and comply with legal obligations. We do not sell or rent your personal information to third parties.',
          }, {
            title: '3. Data Security',
            text: 'We implement industry-standard security measures including SSL encryption, secure hosting, and access controls to protect your data. While we take all reasonable precautions, no internet transmission is 100% secure.',
          }, {
            title: '4. Cookies',
            text: 'We use cookies to enhance user experience, analyze site traffic, and understand user behavior. You can disable cookies in your browser settings, though some features may not function properly.',
          }, {
            title: '5. Third-Party Services',
            text: 'We may use third-party services (analytics, hosting, payment processors) that have their own privacy policies. We only share data necessary for these services to perform their functions.',
          }, {
            title: '6. Your Rights',
            text: 'You have the right to access, correct, or delete your personal data. Contact us at info@formacodetech.com to exercise these rights.',
          }, {
            title: '7. Contact',
            text: 'For privacy-related questions, email info@formacodetech.com.',
          }].map((s) => (
            <div key={s.title} className="reveal">
              <h2 className="font-display text-xl font-bold text-white mb-3">{s.title}</h2>
              <p className="text-white/60 leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}